import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { MasterSummaryPDModel, MasterSummaryQuestionModel, SurveyCutQuestionModel, SurveyVersionQuestionModel } from '../../../../../models/survey/survey.model';
import { PercentageType } from '../../../../../shared/constants/percentage.constants';
import Utils from '../../../../../shared/util/Util';

@Component({
  selector: 'app-percentage-icon-avgRes',
  templateUrl: './percentage-icon-avgRes.component.html',
  styleUrls: ['./percentage-icon-avgRes.component.less']
})
export class PercentageIconComponentAvgRes implements OnInit {
  @Input("surveyMasterSummaryPDModel") survMastSummPDModel: MasterSummaryPDModel;
  @Input("chartJ") chartJ: number;
  @Input("questionI") questionI: number;
  @Input("isCut") isCut: boolean;
  @Input() isCompareMode: boolean = false;
  @Input() isPercentageActivated: boolean = false;
  @Input() isAllResponses: boolean;
  showDropdownPercentage = false;
  private listening = false;
  private globalClick: any;
  @Output() onSelectPercentage = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

  displayDropdownPercentage(element) {
    this.showDropdownPercentage = !this.showDropdownPercentage;
    if (this.showDropdownPercentage && !this.isPercentageActivated) {
      this.globalClick = Observable
        .fromEvent(document, 'click')
        .delay(100)
        .do(() => {
          this.listening = true;
        }).subscribe((event: MouseEvent) => {
          this.onGlobalClick(element, event);
        });
    } else if(this.isPercentageActivated && !this.showDropdownPercentage) {
      this.listening = false;
      this.globalClick.unsubscribe();
    }else{
      this.resetAllDataTurnOffIcon();
      this.showDropdownPercentage = false;
      this.onSelectPercentage.emit(true);
    }
  }

  onGlobalClick(element, event: MouseEvent) {
    if (event instanceof MouseEvent && this.listening === true) {
      if (!this.isDescendant(element.target, event.target)) {
        this.showDropdownPercentage = false;
        this.listening = false;
        this.globalClick.unsubscribe();
      }
    }
  }

  isDescendant(parent, child) {
    let node = child;
    while (node !== null) {
      if (node === parent) {
        return true;
      } else {
        node = node.parentNode;
      }
    }
    return false;
  }

  calculatePercentage(_percentageType: string){
    if(!this.isPercentageActivated){
      if(this.isCompareMode){
        let masterChart = this.obtainMasterChartObject();
        let questionIndex = this.isAllResponses ? this.chartJ : this.questionI;
        if(this.survMastSummPDModel && this.survMastSummPDModel.listSurveyCutQuestion){
          if(PercentageType.RELATIVE === _percentageType){
            this.calculateAllRelative(masterChart,this.survMastSummPDModel.listSurveyCutQuestion,questionIndex);
          }else if(PercentageType.ABSOLUTE === _percentageType){
            this.calculateAllAbsolute(masterChart,this.survMastSummPDModel.listSurveyCutQuestion,questionIndex);
          }
        }
        if (this.survMastSummPDModel && this.survMastSummPDModel.listSurveyVersionQuestion){
          if(PercentageType.RELATIVE === _percentageType){
            this.calculateAllRelative(masterChart,this.survMastSummPDModel.listSurveyVersionQuestion,questionIndex);
          }else if(PercentageType.ABSOLUTE === _percentageType){
            this.calculateAllAbsolute(masterChart,this.survMastSummPDModel.listSurveyVersionQuestion,questionIndex);
          }
        }
        if(this.survMastSummPDModel && this.survMastSummPDModel.listQuestionModel){
          if(PercentageType.RELATIVE === _percentageType){
            this.calculateAllRelativeAllResponses(masterChart,this.survMastSummPDModel.listQuestionModel,questionIndex);
          }else if(PercentageType.ABSOLUTE === _percentageType){
            this.calculateAllAbsoluteAllResponses(masterChart,this.survMastSummPDModel.listQuestionModel,questionIndex);
          }
        }
        this.resetChart(masterChart);
        if(PercentageType.RELATIVE === _percentageType){
          masterChart.averageTypePercentageSelected = PercentageType.RELATIVE;
        }else if(PercentageType.ABSOLUTE === _percentageType){
          masterChart.averageTypePercentageSelected = PercentageType.ABSOLUTE;
        }
        this.changeChartSelection(false);
        this.onSelectPercentage.emit(true);
      }
    }else{
      this.resetAllDataTurnOffIcon();
    }
  }

  get PercentageType(): typeof PercentageType {
    return PercentageType
  }

  //This function return the chose chart based on the input parameters chartJ and questionI and if isCutQuestion or not
  private obtainMasterChartObject(): MasterSummaryQuestionModel{
    if(this.isAllResponses){
      return this.survMastSummPDModel.listQuestionModel[this.chartJ];
    }else{
      if(!this.isCut){
        return this.survMastSummPDModel.listSurveyVersionQuestion[this.chartJ].listQuestionModel[this.questionI];
      }else{
        return this.survMastSummPDModel.listSurveyCutQuestion[this.chartJ].listQuestionModel[this.questionI];
      }
    }
  }

  /*This function will iterate over all chart and it will call the function to calculate the relative percentage difference
   *It will also reset the masterChart to not show the percentage difference in that chart
   */
   private calculateAllRelative(masterChart: MasterSummaryQuestionModel,listQuestion: SurveyVersionQuestionModel[] | SurveyCutQuestionModel[],questionIndex: number){
    let i: number;
    let auxChart: MasterSummaryQuestionModel;
    for(i=0;i<listQuestion.length;i++){
      auxChart = listQuestion[i].listQuestionModel[questionIndex];
      this.calculateRelative(masterChart,auxChart);
    }
  }
  
  /*This function will iterate over all chart and it will call the function to calculate the relative percentage difference
   *It will also reset the masterChart to not show the percentage difference in that chart
   */
   private calculateAllAbsolute(masterChart: MasterSummaryQuestionModel,listQuestion: SurveyVersionQuestionModel[] | SurveyCutQuestionModel[],questionIndex: number){
    let i: number;
    let auxChart: MasterSummaryQuestionModel;
    for(i=0;i<listQuestion.length;i++){
      auxChart = listQuestion[i].listQuestionModel[questionIndex];
      this.calculateAbsolute(masterChart,auxChart);
    }
  }

  private calculateAllRelativeAllResponses(masterChart: MasterSummaryQuestionModel,listQuestion: MasterSummaryQuestionModel[],questionIndex: number){
    this.calculateRelative(masterChart,listQuestion[questionIndex]);
  }

  private calculateAllAbsoluteAllResponses(masterChart: MasterSummaryQuestionModel,listQuestion: MasterSummaryQuestionModel[],questionIndex: number){
    this.calculateAbsolute(masterChart,listQuestion[questionIndex]);
  }

  //This function will apply this formula ((PercentageSibling - PercentageMaster)/PercentageMaster)*100 to each question in the charts
  private calculateRelative(masterChart: MasterSummaryQuestionModel,siblingChart: MasterSummaryQuestionModel){
    if(masterChart && siblingChart){
      siblingChart.averageTypePercentageSelected = PercentageType.RELATIVE;
      siblingChart.averageDiffPercShow = true;
      let masterPercentage = masterChart.averageValue;
      siblingChart.averageDiffPercentage = 0.0;
      let numerator = siblingChart.averageValue - masterPercentage;
      if(masterPercentage != 0){
        let diffPercentage = (numerator/masterPercentage)*100;
        siblingChart.averageDiffPercentage = Utils.roundNumber(diffPercentage,1);
      } else if(masterPercentage == 0 && numerator != 0){
        siblingChart.averageDiffPercentage = null;
        siblingChart.averageDiffPercShow = false;
      }
    }
  }

  //This function will apply this formula PercentageSibling - PercentageMaster to each question in the charts
  private calculateAbsolute(masterChart: MasterSummaryQuestionModel,siblingChart: MasterSummaryQuestionModel){
    if(masterChart && siblingChart){
      siblingChart.averageTypePercentageSelected = PercentageType.ABSOLUTE;
      siblingChart.averageDiffPercShow = true;
      let masterPercentage = masterChart.averageValue;
      let siblingPercentage = siblingChart.averageValue - masterPercentage;
      siblingChart.averageDiffPercentage = Utils.roundNumber(siblingPercentage,1);
    }
  }

  //This funciton will put the property answerDiffPercShow in false and answerDiffPercentage in null to reset this chart
  private resetChart(chart: MasterSummaryQuestionModel){
    if(chart){
      chart.averageTypePercentageSelected = null;
      chart.averageDiffPercShow = false;
      chart.averageDiffPercentage = null;
    }
  }

  //This function sets to true only the chart that has the diff percentage activated
  private changeChartSelection(reset:boolean){
    if(this.survMastSummPDModel){
      this.changeChartSelectionAllResponses(reset);
      this.changeChartSelectionOtherList(this.survMastSummPDModel.listSurveyCutQuestion,reset,true);
      this.changeChartSelectionOtherList(this.survMastSummPDModel.listSurveyVersionQuestion,reset,false);
    }
  }

  private changeChartSelectionAllResponses(reset:boolean){
    let i: number
    if(this.survMastSummPDModel.listQuestionModel){
      let questionIndex = this.isAllResponses ? this.chartJ : this.questionI;
      for(i=0;i<this.survMastSummPDModel.listQuestionModel.length;i++){
        if(reset){
          if(i == questionIndex){
            this.survMastSummPDModel.listQuestionModel[i].diffPercentageSelectedAvgRes = false;
          }
        }else{
          if(i == questionIndex && this.isAllResponses){
            this.survMastSummPDModel.listQuestionModel[i].diffPercentageSelectedAvgRes = true;
          }else if(i == questionIndex && !this.isAllResponses){
            this.survMastSummPDModel.listQuestionModel[i].diffPercentageSelectedAvgRes = false;
          }else if(i != this.chartJ && this.isAllResponses){
            this.survMastSummPDModel.listQuestionModel[i].diffPercentageSelectedAvgRes = false;
          }
        }
      }
    }
  }

  private changeChartSelectionOtherList(chartList: SurveyVersionQuestionModel[] | SurveyCutQuestionModel[],reset:boolean,isCutList:boolean){
    let i: number;
    let j: number;
    if(chartList){
      let questionIndex = this.isAllResponses ? this.chartJ : this.questionI;
      for(i=0;i<chartList.length;i++){
        for(j=0;j<chartList[i].listQuestionModel.length;j++){
          if(i == this.chartJ && j == questionIndex && !this.isAllResponses && this.isCut == isCutList){
            chartList[i].listQuestionModel[j].diffPercentageSelectedAvgRes = false;
            if(!reset){
              chartList[i].listQuestionModel[j].diffPercentageSelectedAvgRes = true;
            }
          }else if(i == this.chartJ && j == questionIndex){
            chartList[i].listQuestionModel[j].diffPercentageSelectedAvgRes = false;
          }else if(i != this.chartJ && j == questionIndex){
            chartList[i].listQuestionModel[j].diffPercentageSelectedAvgRes = false;
          }
        }
      }
    }
  }

  private resetAllCharts(listQuestion: SurveyVersionQuestionModel[] | SurveyCutQuestionModel[],questionIndex: number){
      let i: number;
      let j: number;
      if(listQuestion){
        for(i=0;i<listQuestion.length;i++){
          for(j=0;j<listQuestion[i].listQuestionModel.length;j++){
            if(j == questionIndex){
              this.resetChart(listQuestion[i].listQuestionModel[j]);
            }
          }
        }
      }
  }

  private resetAllResponses(questionIndex: number){
    this.resetChart(this.survMastSummPDModel.listQuestionModel[questionIndex]);
  }

  private resetAllDataTurnOffIcon(){
    this.changeChartSelection(true);
    let questionIndex = this.isAllResponses ? this.chartJ : this.questionI;
    this.resetAllCharts(this.survMastSummPDModel.listSurveyCutQuestion,questionIndex);
    this.resetAllCharts(this.survMastSummPDModel.listSurveyVersionQuestion,questionIndex);
    this.resetAllResponses(questionIndex);
  }
}






// WEBPACK FOOTER //
// ./src/app/routes/surveys/master-summary/icon-dropdown/percentage-icon-AvgRes/percentage-icon-avgRes.component.ts